module.exports = __webpack_public_path__ + "static/media/interview_icon.d05816ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interview_icon.svg
// module id = 1016
// module chunks = 1